import { useLocation } from "react-router-dom";

import { useSearchPageQueryParams } from "@faire/retailer/views/search-v2/SearchPageQueryParams/useSearchPageQueryParams";

export const useSearchPageProductSearchString = () => {
  const { pathname } = useLocation();
  const query = useSearchPageQueryParams().searchQuery;

  return pathname.startsWith("/brand") ? "" : query;
};
